import commonUtil from "../../../utils/commonUtil";

export const ALLOWED_EVENT_TYPES_LOAD = "ALLOWED_EVENT_TYPES_LOAD";
export const ALLOWED_EVENT_TYPES_LOAD_SUCCESS =
  "ALLOWED_EVENT_TYPES_LOAD_SUCCESS";
export const ALLOWED_EVENT_TYPES_LOAD_FAIL = "ALLOWED_EVENT_TYPES_LOAD_FAIL";

export function isAllowedEventTypesLoaded(globalState) {
  return globalState.allowedEventTypes && globalState.allowedEventTypes.loaded;
}

export function loadAllowedEventTypes() {
  const _allowedEventTypes = {};
  _allowedEventTypes.brand = commonUtil.getBrand();
  _allowedEventTypes.channel = commonUtil.getChannel();

  return {
    types: [
      ALLOWED_EVENT_TYPES_LOAD,
      ALLOWED_EVENT_TYPES_LOAD_SUCCESS,
      ALLOWED_EVENT_TYPES_LOAD_FAIL,
    ],
    promise: (client) =>
      client.post("/api/isEventEligibleToCreate", {
        data: _allowedEventTypes,
      }),
  };
}
